import { ValueFormatterParams } from 'ag-grid-enterprise'

import { numberFormatter } from '@fortem-monorepo/js-utilities'

export const toDecimalPlaces = (number: number, decimalPlaces: number = 2) => {
  const factor = 10 ** decimalPlaces
  return Math.trunc(number * factor) / factor
}

export const to2dpNoRounding = (params: ValueFormatterParams) => {
  if (typeof params.value === 'number') {
    return toDecimalPlaces(params.value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }
  return params.value
}

export const baseFormatter = numberFormatter({
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  delimiter: true,
})

export const percentFormatter = numberFormatter({
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  suffix: '%',
  transformer: (val) => val * 100,
})
